<div class="body-app">
    <app-navigation></app-navigation>
    <main class="page">
        <router-outlet></router-outlet>
    </main>
    <app-footer></app-footer>
</div>
<div class="arrow_up mw40px" (window:scroll)="scrollHidden()" [hidden]="showArrow">
    <div class="up" (click)="goToTop()">
        <img src="assets/img/chevup.png" alt="up" class="w-100">
    </div>
</div>